import { useQuery } from 'react-query';
import { configuration } from 'apis';

const useChecklistQueries = () => {
    const eventDataQuery = useQuery(['checklistScreenEvent'], async () => configuration.getLKEvents());

    const disciplineDataQuery = useQuery(['checklistScreenDiscipline'], async () => configuration.getDisciplines());

    const ageCategoryDataQuery = useQuery(['checklistScreenAgeCategory'], async () => configuration.getAgeCategories());

    const divisionDataQuery = useQuery(['checklistScreenDivision'], async () => configuration.getDivisions());

    const competitionTypeDataQuery = useQuery(['checklistScreenCompetitionType'], async () => configuration.getCompetitionTypes());

    const seasonDataQuery = useQuery(['checklistScreenSeason'], async () => configuration.getLKSeason());

    const applicationTypeProductAgesDataQuery = useQuery(['checklistScreenApplicationTypeProductAges'], async () =>
        configuration.getApplicationTypeProductAges()
    );

    const applicationTypeProductServicesDataQuery = useQuery(['checklistScreenApplicationTypeProductServices'], async () =>
        configuration.getApplicationTypeProductServices()
    );

    const fileTypesDataQuery = useQuery(['checklistScreenFileTypes'], async () => configuration.getFileTypes());

    const applicationTypeDataQuery = useQuery(['checklistScreenApplicationType'], async () => configuration.getApplicationType());

    const optionalAnswerDataQuery = useQuery(['checklistScreenOptionalAnswers'], async () => configuration.getOptionalAnswers());

    const questionDataQuery = useQuery(['checklistScreenQuestion'], async () => configuration.getQuestion());

    useQuery(['checklistScreenProductServices'], async () => configuration.getProductServices());

    return {
        eventDataQuery,
        disciplineDataQuery,
        ageCategoryDataQuery,
        divisionDataQuery,
        competitionTypeDataQuery,
        seasonDataQuery,
        applicationTypeProductAgesDataQuery,
        applicationTypeProductServicesDataQuery,
        fileTypesDataQuery,
        applicationTypeDataQuery,
        optionalAnswerDataQuery,
        questionDataQuery
    };
};

export default useChecklistQueries;
